<template>
    <div>
        <loading
            :active.sync="loadingContent"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <div class="appHeader shadow-header-footer">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Layanan Bantuan</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" v-if="loadingContent == false">
            <ul class="listview image-listview inset mt-3 mr-3 ml-3 mb-4">
                <li>
                    <router-link :to="{ name: 'faq' }" class="item">
                        <div class="icon-box bg-primary">
                            <ion-icon name="help"></ion-icon>
                        </div>
                        <div class="in">
                            <div>
                                <b style="font-weight: bold">F.A.Q</b>
                                <footer>Frequently Asked Question</footer>
                            </div>
                        </div>
                    </router-link>
                </li>
                <li v-for="item in care_center" :key="item.id">
                    <a :href="item.url_redirect" class="item" target="_blank">
                        <div class="icon-box bg-primary">
                            <ion-icon name="headset-outline"></ion-icon>
                        </div>
                        <div class="in">
                            <div>
                                <b style="font-weight: bold">{{ item.name }}</b>
                                <footer>Customer Service</footer>
                            </div>
                        </div>
                    </a>
                </li>
                <!-- <li>
                    <router-link :to="{ name: 'channel' }" class="item">
                        <div class="icon-box bg-primary">
                            <ion-icon name="people-outline"></ion-icon>
                        </div>
                        <div class="in">
                            <div>
                                <b style="font-weight: bold"
                                    >Komunitas Mitra
                                    {{ VUE_ENV.VUE_APP_NAME }}</b
                                >
                                <footer style="font-size: 11px">
                                    Bergabung di channel Mitra
                                    {{ VUE_ENV.VUE_APP_NAME }} untuk mendapatkan
                                    berbagai informasi seputar
                                    {{ VUE_ENV.VUE_APP_NAME }} serta Tips & Trik
                                    lainnya
                                </footer>
                            </div>
                        </div>
                    </router-link>
                </li> -->
            </ul>
            <!-- <div class="section m-3">
        <div>
          <div class="p-1">
            <div class="text-center">
              <h2 class="text-primary mb-2">Media Sosial</h2>

              <a
                href="https://web.facebook.com/qiosfincom"
                target="_blank"
                class="btn btn-facebook btn-icon mr-05"
              >
                <ion-icon name="logo-facebook"></ion-icon>
              </a>

              <a
                href="http://tanya.web.id/tanya-difa"
                target="_blank"
                class="btn btn-whatsapp btn-icon mr-05"
              >
                <ion-icon name="logo-whatsapp"></ion-icon>
              </a>

              <a
                href="https://www.instagram.com/qiosfincom/"
                target="_blank"
                class="btn btn-instagram btn-icon mr-05"
              >
                <ion-icon name="logo-instagram"></ion-icon>
              </a>

              <a
                href="https://t.me/qiosfincom/"
                target="_blank"
                class="btn btn-primary btn-icon mr-05"
              >
                <ion-icon name="paper-plane"></ion-icon>
              </a>
            </div>
          </div>
        </div>
      </div> -->
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import $axios from './../api.js';
    export default {
        data() {
            return {
                loadingContent: true,
                care_center: [],
                amount: '',
            };
        },
        created() {
            this.getCareCcenter();
        },
        computed: {
            ...mapState(['loading', 'toast', 'VUE_ENV']),
        },
        methods: {
            getCareCcenter() {
                $axios
                    .get('/care-center')
                    .then(response => {
                        this.care_center = response.data.data;
                        this.loadingContent = false;
                    })
                    .catch(() => {
                        this.loadingContent = false;
                    });
            },
            press(key) {
                console.log(key);
            },
        },
        mounted() {
            document.body.classList.remove('bg-white');
        },
    };
</script>
